import { login, logout } from '@/lib/auth-client';

// Compatibility shim for `next-auth/react`. Staff auth now goes through the
// Laravel API with a bearer/cookie session (see src/lib/auth-client.ts).
export interface SignInOptions {
  email?: string;
  password?: string;
  redirect?: boolean;
  callbackUrl?: string;
}

export interface SignInResult {
  error: string | null;
  ok: boolean;
  url?: string;
}

export async function signIn(
  _provider: string,
  options: SignInOptions = {},
): Promise<SignInResult> {
  if (!options.email || !options.password) return { error: 'CredentialsRequired', ok: false };
  try {
    await login(options.email, options.password);
    return { error: null, ok: true, url: options.callbackUrl ?? '/admin' };
  } catch {
    return { error: 'CredentialsSignin', ok: false };
  }
}

export async function signOut(_options: { redirect?: boolean } = {}): Promise<{ url: string }> {
  await logout();
  return { url: '/login' };
}

export function useSession(): { data: null; status: 'unauthenticated' } {
  return { data: null, status: 'unauthenticated' };
}
